import { api } from './configs/axiosConfig';
import { PLATFORM_HOST_KEY } from '../constants';
export const ConfigurationAPI = {
    // Get all configurations with optional type filter
    getConfigurations: async function (type) {
        const params = type ? { type } : {};
        const response = await api.get('/configuration', { params });
        return response?.data;
    },
    // Get public user experience configuration (no auth required)
    getPublicUserExperienceConfig: async function () {
        const response = await api.get('/configuration/public');
        return response?.data;
    },
    // Get configuration by ID
    getConfigurationById: async function (id) {
        const response = await api.get(`/configuration/${id}`);
        return response?.data;
    },
    // Create new configuration
    createConfiguration: async function (data) {
        const response = await api.post('/configuration', data);
        return response?.data;
    },
    // Update configuration by ID
    updateConfiguration: async function (id, data) {
        const response = await api.put(`/configuration/${id}`, data);
        return response?.data;
    },
    // Delete configuration by ID
    deleteConfiguration: async function (id) {
        await api.delete(`/configuration/${id}`);
    },
    // Get the platform host URL from System configuration
    getPlatformHost: async function () {
        try {
            const bundle = await ConfigurationAPI.getConfigurations('System');
            for (const config of bundle.resource) {
                const item = config.items.find((i) => i.key === PLATFORM_HOST_KEY);
                if (item) {
                    if (typeof item.value === 'string')
                        return item.value;
                    if (typeof item.value === 'object')
                        return JSON.stringify(item.value);
                    return String(item.value);
                }
            }
        }
        catch {
            // fall through to return empty string
        }
        return '';
    }
};
